import React from "react";
import { Link } from "react-router-dom";
import {
  ArrowRight,
  ClipboardList,
  Target,
  TrendingUp,
  HeartHandshake,
  Sparkles,
  LockKeyhole
} from "lucide-react";

import "../styles/PATINHome.css";

const etapas = [
  {
    numero: "01",
    titulo: "Conheça seu negócio",
    descricao:
      "Conte um pouco sobre você, seus produtos, suas clientes e seus desafios.",
    icon: ClipboardList
  },
  {
    numero: "02",
    titulo: "Descubra oportunidades",
    descricao:
      "Identifique os pontos fortes e o que pode melhorar no seu negócio.",
    icon: Sparkles
  },
  {
    numero: "03",
    titulo: "Construa seu plano",
    descricao:
      "Escolha prioridades e organize ações práticas para transformar seu negócio.",
    icon: Target
  },
  {
    numero: "04",
    titulo: "Acompanhe sua evolução",
    descricao:
      "Registre conquistas e acompanhe os resultados junto com sua consultora.",
    icon: TrendingUp
  }
];

export default function PATINHome() {
  return (
    <main className="patin-home">
      <header className="patin-header">
        <Link to="/" className="patin-brand">
          <span className="patin-brand-icon">✦</span>
          <span>INSTITUTO IMA</span>
        </Link>

        <span className="patin-programa">
          PROGRAMA NUNCA FOI SÓ BATOM
        </span>
      </header>

      <section className="patin-hero">
        <div className="patin-hero-content">
          <span className="patin-eyebrow">
            PLANO DE ACELERAÇÃO, TRANSFORMAÇÃO E INOVAÇÃO
          </span>

          <h1>
            Seu negócio tem uma história.
            <span> Vamos construir o próximo capítulo?</span>
          </h1>

          <p>
            O PATIN é um espaço para conhecer melhor seu
            empreendimento, descobrir oportunidades e planejar
            mudanças que fazem sentido para sua realidade.
          </p>

          <div className="patin-hero-actions">
            <a href="#como-funciona" className="patin-button-primary">
              Conhecer meu PATIN
              <ArrowRight size={19} />
            </a>

            <a href="#sobre" className="patin-button-secondary">
              Saiba mais
            </a>
          </div>

          <div className="patin-hero-note">
            <HeartHandshake size={19} />
            <span>
              Uma jornada construída por você, com apoio da sua consultora.
            </span>
          </div>
        </div>

        <div className="patin-hero-art" aria-hidden="true">
          <div className="patin-art-circle">
            <span className="patin-art-star">✳</span>
            <span className="patin-art-title">PATIN</span>
            <span className="patin-art-subtitle">
              Meu negócio.<br />
              Minhas conquistas.<br />
              Meu futuro.
            </span>
          </div>
          <div className="patin-art-decoration decoration-one" />
          <div className="patin-art-decoration decoration-two" />
        </div>
      </section>

      <section id="sobre" className="patin-intro">
        <span className="patin-section-label">
          SOBRE O PATIN
        </span>

        <h2>
          Transformar começa com um primeiro passo.
        </h2>

        <p>
          Inovar não significa necessariamente usar tecnologia.
          Pode ser melhorar um produto, organizar as vendas,
          atender melhor suas clientes ou encontrar novas
          maneiras de fazer seu negócio crescer.
        </p>
      </section>

      <section id="como-funciona" className="patin-steps-section">
        <div className="patin-section-heading">
          <span className="patin-section-label">
            SUA JORNADA
          </span>

          <h2>Como funciona?</h2>

          <p>
            Quatro movimentos para entender, planejar
            e acompanhar a transformação do seu negócio.
          </p>
        </div>

        <div className="patin-steps-grid">
          {etapas.map((etapa) => {
            const Icon = etapa.icon;

            return (
              <article
                className="patin-step-card"
                key={etapa.numero}
              >
                <span className="patin-step-number">
                  {etapa.numero}
                </span>

                <div className="patin-step-icon">
                  <Icon size={27} strokeWidth={1.8} />
                </div>

                <h3>{etapa.titulo}</h3>
                <p>{etapa.descricao}</p>
              </article>
            );
          })}
        </div>
      </section>

      <section className="patin-cta-section">
        <div className="patin-cta-content">
          <span className="patin-section-label">
            EM BREVE
          </span>

          <h2>
            Seu espaço de transformação está sendo preparado.
          </h2>

          <p>
            Aqui você poderá preencher seu diagnóstico,
            construir seu plano e acompanhar sua evolução
            junto com sua consultora.
          </p>

          <div className="patin-coming-soon">
            <LockKeyhole size={18} />
            Acesso às participantes e consultoras em preparação
          </div>
        </div>
      </section>

      <footer className="patin-footer">
        <span>Instituto IMA</span>
        <span>Nunca Foi Só Batom • PATIN Digital</span>
      </footer>
    </main>
  );
}
